import { useSearchParams } from 'react-router-dom';
import { StoreTabs } from '@appcharge/shared-ui';
import { TabData } from 'constants/apiResponses.types';
import { StyledFooterTabs } from './style';

export const FooterTabs: React.FC<{ tabs: TabData[] }> = ({ tabs }) => {
  return (
    <StyledFooterTabs>
      <StoreTabs tabs={tabs} useSearchParams={useSearchParams} isBottom />
    </StyledFooterTabs>
  );
};
